import React from 'react'
import Popup from '../../../../../components/popup/Popup'
import Button from '../../../../../components/button/Button'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import styles from "../ManageFederalForms.styles"
import commonStyles from "../../ManageForms.styles"
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import Label from '../../../../../components/label/Label'
import RadioInput from '../../../../../components/input/radioinput/RadioInput'
import MultiSelectDropdownWButton from '../../../../../components/multiselect/multiselectdropdownwbuttons/MultiSelectDropdownWButtons'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'
import CheckboxWLabel from '../../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import HorizontalSeparator from '../../../../../components/separator/horizontalSeparator/HorizontalSeparator'

const CHECKBOX_NAME_TEXTS = {
    MERGE_COPIES: 'mergeCopies'
}

const DownloadPdf = ({
    isPopupOpen,
    onCloseCb,
    downloadPdfByForm = false,
    downloadPdfByPayerAndForm = false,
    downloadPdfByReference = false,
    isPdfType = true,
    onSelectOptionsCb = () => { },
    onChangeRadioCb = () => { },
    federalForms = [],
    federalPayers = [],
    referenceNumber = [],
    downloadPdfStates = {},
    downloadPdfType = "",
    onSubmitCb = () => { },
    onSelectMultipleOptionsCb = () => { },
    checkboxValues = {},
    onChangeCheckBoxCb = () => { },
}) => {

    return (
        <>
            <Popup
                title={"Download PDF"}
                isPopupOpen={isPopupOpen}
                onCloseCb={onCloseCb}
                childrenStyles={styles.childrenStyles}
                customPopupSyles={styles.customPopupSyles}
            >
                <div style={styles.dropdownContainer}>
                    {downloadPdfByPayerAndForm &&
                        <MultiSelectDropdownWButton
                            label='Select Payer'
                            options={federalPayers}
                            searchFieldPlaceholder="Search by payer"
                            suffixProps={{ icon: VEC_ICON_NAME.CARET_DOWN }}
                            onSelectOptionsCb={onSelectMultipleOptionsCb}
                        />
                    }

                    {downloadPdfByForm || downloadPdfByPayerAndForm ?
                        <SelectDropdown
                            label='Select Form'
                            name="Forms"
                            options={federalForms}
                            dropdownMenuStyle={styles.dropdownMenu}
                            value={downloadPdfStates.Forms}
                            onSelectCb={onSelectOptionsCb}
                        /> : ""
                    }
                </div>

                {downloadPdfByReference &&
                    <SelectDropdown
                        label='Select Reference'
                        name="Reference"
                        options={referenceNumber}
                        dropdownMenuStyle={styles.dropdownMenu}
                        value={downloadPdfStates.Reference}
                        onSelectCb={onSelectOptionsCb}
                    />
                }


                {isPdfType && <Label customStyles={styles.radioGroup}>Please select the copy you want to download</Label>}

                {isPdfType && <>
                    <div style={styles.radioBox}>
                        <RadioInput
                            name="all"
                            label={{ suffixLabel: "All Copies" }}
                            value={true}
                            customStyle={styles.radioLabel}
                            onChangeCb={onChangeRadioCb}
                            checked={downloadPdfType == "all"}
                        />

                        <RadioInput
                            name="payee"
                            label={{ suffixLabel: "Recipient Copy" }}
                            value={true}
                            customStyle={styles.radioLabel}
                            onChangeCb={onChangeRadioCb}
                            checked={downloadPdfType == "payee"}
                        />

                        <RadioInput
                            name="payer"
                            label={{ suffixLabel: "Payer Copy" }}
                            value={false}
                            customStyle={styles.radioLabel}
                            onChangeCb={onChangeRadioCb}
                            checked={downloadPdfType == "payer"}
                        />

                    </div>
                    <HorizontalSeparator />
                    <div style={styles.checkboxContainer}>
                        <CheckboxWLabel label="Merge Copies" name={CHECKBOX_NAME_TEXTS.MERGE_COPIES} checked={checkboxValues[CHECKBOX_NAME_TEXTS.MERGE_COPIES]} onChangeCb={onChangeCheckBoxCb} />
                    </div>
                </>
                }

                <div style={styles.buttonsContainer}>
                    <Button style={commonStyles.button} onClickCb={onSubmitCb}>Submit</Button>
                    <Button style={commonStyles.button} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={onCloseCb}>Cancel</Button>
                </div>
            </Popup>
        </>
    )
}

export default DownloadPdf
